<template>
  <Dialog @update:open="reset">
    <DialogTrigger>
      <slot />
    </DialogTrigger>
    <DialogContent to="#notification-dialogs" class="w-[270px] rounded-lg">
      <DialogHeader>
        <VisuallyHidden>
          <DialogTitle>Masquage personnalisé</DialogTitle>
          <DialogDescription>Masquage personnalisé</DialogDescription>
        </VisuallyHidden>
      </DialogHeader>
      <div class="flex flex-col gap-2 text-sm">
        <div class="flex items-center justify-between">
          <div>Masquer jusqu'au :</div>
          <div>
            <Popover v-model:open="state.showCalendar" :modal="true" @update:open="(event) => state.showCalendar = event">
              <PopoverTrigger as-child>
                <button class="hide-options flex w-[105px] items-center">
                  <Icon name="mdi-calendar" />
                  {{ state.hideUntil ? dateHelper.shortFormat(state.hideUntil.toString()) : "Choisir" }}
                </button>
              </PopoverTrigger>
              <PopoverContent class="w-auto p-0">
                <Calendar v-model="state.hideUntil as DateValue" locale="fr-FR" initial-focus />
              </PopoverContent>
            </Popover>
          </div>
        </div>
        <div class="flex items-center justify-between gap-1">
          <div>Sélection rapide:</div>
          <div class="flex gap-1">
            <button class="hide-options" @click="addDay(30)">
              30 jours
            </button>
            <button class="hide-options" @click="addDay(365)">
              1 an
            </button>
          </div>
        </div>
        <Input v-model="state.reason" type="text" placeholder="Une raison à préciser ?" />
      </div>
      <DialogFooter>
        <DialogClose as-child>
          <Button type="submit" class="bg-primary text-white" :disabled="!state.hideUntil" @click="submit">
            <Icon name="mdi-check" class="text-white" />
            Masquer
          </Button>
        </DialogClose>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<script lang="ts" setup>
import {reactive, watch} from 'vue';
import Icon from "@/core/components/icon/Icon.vue";
import {Button} from "@/core/components/ui/button";
import {Popover, PopoverTrigger, PopoverContent} from "@/core/components/ui/popover";
import {Calendar} from "@/core/components/ui/calendar";
import dateHelper from "../../../../core/helpers/dateHelper";
import {Input} from "@/core/components/ui/input";
import {
    Dialog,
    DialogTrigger,
    DialogHeader,
    DialogContent,
    DialogTitle,
    DialogDescription, DialogFooter, DialogClose
} from "@/core/components/ui/dialog";
import {VisuallyHidden} from "reka-ui";
import {today, getLocalTimeZone, type DateValue} from "@internationalized/date";
import dayjs from "dayjs";
import {useNotificationStore} from "@/stores/notification.store";

const emit = defineEmits(['submit']);
const store = useNotificationStore();

const state = reactive({
    hideUntil: undefined as DateValue | undefined,
    reason: '' as string,
    showCalendar: false
});

watch(() => state.hideUntil, () => {
    state.showCalendar = false;
});

/**
 * Add days to the current date.
 * @param days
 */
const addDay = (days: number) => {
    state.hideUntil = today(getLocalTimeZone()).add({days: days});
};

/**
 * Submit the user input.
 */
const submit = () => {
    emit('submit', dayjs(state.hideUntil?.toDate(getLocalTimeZone())).diff(dayjs(), 'day'), state.reason);
};

/**
 * Reset the user input.
 */
const reset = (openState: boolean) => {
    state.hideUntil = undefined;
    state.reason = '';
    state.showCalendar = false;
    store.modalOpen = openState;
};
</script>

<style scoped>
button.hide-options {
    @apply bg-gray-100 px-2 py-1 rounded hover:bg-gray-200;
}
</style>
